import { Action, createReducer, on } from '@ngrx/store';

import { SupplierRequestListV1 } from '../../../../api/models';
import { DynamicFilter } from '../../../../api/models/dynamic-filter';
import {
  loadFirstPageRequests,
  loadNextPageRequests,
  loadPageRequestsFailure,
  loadPageRequestsSuccess,
  resetRequestsList,
  RequestListSource,
} from '../../actions/request/request.actions';

export interface RequestState {
  items: SupplierRequestListV1[];
  continuationToken: string | null;
  hasMore: boolean;
  loading: boolean;
  error: unknown;
  lastFilters: DynamicFilter[];
  lastSortBy: string | undefined;
  lastSortDirection: 'ASC' | 'DESC' | undefined;
  lastSource: RequestListSource;
}

export const initialState: RequestState = {
  items: [],
  continuationToken: null,
  hasMore: true,
  loading: false,
  error: null,
  lastFilters: [],
  lastSortBy: undefined,
  lastSortDirection: undefined,
  lastSource: 'all',
};

const requestReducer = createReducer(
  initialState,

  on(loadFirstPageRequests, (_state, { filters, sortBy, sortDirection, source }) => ({
    ...initialState,
    loading: true,
    lastFilters: filters,
    lastSortBy: sortBy,
    lastSortDirection: sortDirection,
    lastSource: source ?? 'all',
  })),

  on(loadNextPageRequests, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(loadPageRequestsSuccess, (state, { content, continuationToken, hasMore }) => ({
    ...state,
    items: [...state.items, ...content],
    continuationToken,
    hasMore,
    loading: false,
    error: null,
  })),

  on(loadPageRequestsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(resetRequestsList, () => initialState)
);

export function reducer(state: RequestState | undefined, action: Action) {
  return requestReducer(state, action);
}
